import {
  DangerButton,
  GreyPrimaryAlternativeButton,
  PrimaryAlternativeButton,
  PrimaryBlueButton,
  PrimaryButton,
  SecondaryButton,
  SmallPrimaryButton,
} from './Button';
import { PrimaryLink } from './ButtonLink';

export enum ButtonTypes {
  Danger = 'Danger',
  GreyPrimaryAlternative = 'GreyPrimaryAlternative',
  Primary = 'Primary',
  PrimaryAlternative = 'PrimaryAlternative',
  PrimaryBlue = 'PrimaryBlue',
  PrimaryLink = 'PrimaryLink',
  Secondary = 'Secondary',
  SmallPrimary = 'SmallPrimary',
}

export const buttons = {
  [ButtonTypes.Danger]: DangerButton,
  [ButtonTypes.GreyPrimaryAlternative]: GreyPrimaryAlternativeButton,
  [ButtonTypes.Primary]: PrimaryButton,
  [ButtonTypes.PrimaryAlternative]: PrimaryAlternativeButton,
  [ButtonTypes.PrimaryBlue]: PrimaryBlueButton,
  [ButtonTypes.PrimaryLink]: PrimaryLink,
  [ButtonTypes.Secondary]: SecondaryButton,
  [ButtonTypes.SmallPrimary]: SmallPrimaryButton,
};
